interface Values {
  key: string;
  value: string;
}

const pushValuesToDataLayer = (values: Values[]) => {
  if (window && values && values.length > 0) {
    window.dataLayer = window.dataLayer || [];
    values.map((x) => {
      if (!window.dataLayer.find((y: any) => y[x.key] != undefined)) {
        const a = {} as any;
        a[x.key] = x.value;
        window.dataLayer.push(a);
      }
    });
  }
};
export default pushValuesToDataLayer;
